const appConfig = {
  name: "Intelligent Monitoring System (IMS)",
  version: "3.3.2",
  copyright: <> &copy; CELCOMDIGI {new Date().getFullYear()}. All Rights Reserved </>,
};

export default appConfig;
